import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LeftSidebar from './LeftSidebar';
import Topbar from './Topbar';
import Footer from './Footer';
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from '../Config';
import Swal from "sweetalert2";

const MemberEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Form state expected by backend (names aligned with Laravel)
  const [membershipNo, setMembershipNo] = useState('');
  const [firmName, setFirmName] = useState('');
  const [address, setAddress] = useState('');
  const [firmMobile, setFirmMobile] = useState('');
  const [area, setArea] = useState('');

  // Optional alternate mobile (NOT used by backend update you provided, kept if needed in UI)
  const [firmAlternateMobile, setFirmAlternateMobile] = useState('');

  // Representatives up to 5 (name/mobile)
  const [rep1Name, setRep1Name] = useState('');
  const [rep1Mobile, setRep1Mobile] = useState('');
  const [rep2Name, setRep2Name] = useState('');
  const [rep2Mobile, setRep2Mobile] = useState('');
  const [rep3Name, setRep3Name] = useState('');
  const [rep3Mobile, setRep3Mobile] = useState('');
  const [rep4Name, setRep4Name] = useState('');
  const [rep4Mobile, setRep4Mobile] = useState('');
  const [rep5Name, setRep5Name] = useState('');
  const [rep5Mobile, setRep5Mobile] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const resp = await axios.get(`${BASE_URL}/api/member_edit/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const m = resp.data.list || {};

        // Map backend -> UI. Adjust keys based on what member_edit returns.
        setMembershipNo(m.membership || '');
        setFirmName(m.company_name || m.name || '');
        setAddress(m.registered_address || m.address || '');
        setFirmMobile(m.registered_contact_no || m.mobile || '');
        setArea(m.area || '');

        // If your API provides alternate number; this is not sent to backend update per current contract
        setFirmAlternateMobile(m.alternate_contact_no || m.mobile_alt || '');

        // Contacts array
       

        setRep1Name(m.rep_name_1 || '');
        setRep1Mobile(m.rep_mobile_1 || '');

        setRep2Name(m.rep_name_2 || '');
        setRep2Mobile(m.rep_mobile_2 || '');

        setRep3Name(m.rep_name_3 || '');
        setRep3Mobile(m.rep_mobile_3 || '');

        setRep4Name(m.rep_name_4 || '');
        setRep4Mobile(m.rep_mobile_4 || '');

        setRep5Name(m.rep_name_5 || '');
        setRep5Mobile(m.rep_mobile_5 || '');

      } catch (error) {
        console.error("Error fetching member data", error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to load member data.' });
      }
    };
    fetchData();
  }, [id]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');

      // Build representatives exactly as Laravel expects
      const representatives = [
        { name: rep1Name, mobile: rep1Mobile },
        { name: rep2Name, mobile: rep2Mobile },
        { name: rep3Name, mobile: rep3Mobile },
        { name: rep4Name, mobile: rep4Mobile },
        { name: rep5Name, mobile: rep5Mobile },
      ].filter(r => (r.name && r.name.trim()) || (r.mobile && r.mobile.trim()));

      // Exact payload keys per your member_update validation
      const payload = {
        id: Number(id),
        membershipNo,
        firmName,
        firmMobile,
        address,
        area,
        representatives
      };

      const res = await fetch(`${BASE_URL}/api/member_update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (res.ok && data.message) {
        Swal.fire({ icon: 'success', title: 'Success', text: data.message })
          .then(() => navigate('/members'));
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: data.error || data.message || 'Update failed.' });
      }
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred during update.' });
    }
  };

  return (
    <div id="page-top">
      <div id="wrapper">
        <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <div className="container-fluid">
              <div className='col-md-10'>
                <div className='card'>
                  <div className='card-header py-3' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                    <div className='row'>
                      <div className='col-md-6 d-flex left-content-end'>
                        <h6 className="font-weight-bold text-primary left">Edit Member</h6>
                      </div>
                      <div className='col-md-6 d-flex justify-content-end'>
                        <i className="fa fa-arrow-left" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}></i>
                      </div>
                    </div>
                  </div>

                  <section>
                    <div className="container-sm">
                      <div className="about-wrap2 position-relative">
                        <div className="row align-items-start" style={{ padding: "2px" }}>
                          <form
                            onSubmit={handleSubmit}
                            className="mx-auto bg-white p-4 rounded shadow"
                            style={{ maxWidth: "900px", textAlign: "left" }}
                          >
                            <hr />
                          {/* Firm Name (firmName) */}
                            <div className="form-group mb-2">
                              <label>Membership</label>
                              <input
                                type="text"
                                name="membershipNo"
                                className="form-control"
                                value={membershipNo}
                                onChange={(e) => setMembershipNo(e.target.value)}
                                required
                              />
                            </div>
                            {/* Firm Name (firmName) */}
                            <div className="form-group mb-2">
                              <label>Firm Name</label>
                              <input
                                type="text"
                                name="firmName"
                                className="form-control"
                                value={firmName}
                                onChange={(e) => setFirmName(e.target.value)}
                                required
                              />
                            </div>

                            {/* Address (address) */}
                            <div className="form-group mb-2">
                              <label>Address</label>
                              <input
                                type="text"
                                name="address"
                                className="form-control"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                required
                              />
                            </div>

                            {/* Firm Mobile (firmMobile) */}
                            <div className="form-group mb-2">
                              <label>Firm Mobile No. (WhatsApp without +91)</label>
                              <input
                                type="text"
                                name="firmMobile"
                                className="form-control"
                                value={firmMobile}
                                maxLength={15}
                                onChange={(e) => setFirmMobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
                                required
                              />
                            </div>

                            {/* Firm Alternate Mobile (not sent to backend) */}
                            <div className="form-group mb-2">
                              <label>Firm Alternate Mobile</label>
                              <input
                                type="text"
                                name="firmAlternateMobile"
                                className="form-control"
                                value={firmAlternateMobile}
                                maxLength={15}
                                onChange={(e) => setFirmAlternateMobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
                              />
                            </div>

                            {/* Area (area) */}
                            <div className="form-group mb-3">
                              <label>Area</label>
                              <input
                                type="text"
                                name="area"
                                className="form-control"
                                value={area}
                                onChange={(e) => setArea(e.target.value)}
                                required
                              />
                            </div>

                            <hr />
                            <h5>Contact Persons</h5>

                            {/* Rep 1 */}
                            <div className="row g-2">
                              <div className="col-md-6">
                                <label>Representative Name-1</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep1Name}
                                  onChange={(e) => setRep1Name(e.target.value)}
                                />
                              </div>
                              <div className="col-md-6">
                                <label>Representative Mobile-1</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep1Mobile}
                                  maxLength={15}
                                  onChange={(e) => setRep1Mobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
                                />
                              </div>
                            </div>

                            {/* Rep 2 */}
                            <div className="row g-2 mt-2">
                              <div className="col-md-6">
                                <label>Representative Name-2</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep2Name}
                                  onChange={(e) => setRep2Name(e.target.value)}
                                />
                              </div>
                              <div className="col-md-6">
                                <label>Representative Mobile-2</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep2Mobile}
                                  maxLength={15}
                                  onChange={(e) => setRep2Mobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
                                />
                              </div>
                            </div>

                            {/* Rep 3 */}
                            <div className="row g-2 mt-2">
                              <div className="col-md-6">
                                <label>Representative Name-3</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep3Name}
                                  onChange={(e) => setRep3Name(e.target.value)}
                                />
                              </div>
                              <div className="col-md-6">
                                <label>Representative Mobile-3</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep3Mobile}
                                  maxLength={15}
                                  onChange={(e) => setRep3Mobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
                                />
                              </div>
                            </div>

                            {/* Rep 4 */}
                            <div className="row g-2 mt-2">
                              <div className="col-md-6">
                                <label>Representative Name-4</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep4Name}
                                  onChange={(e) => setRep4Name(e.target.value)}
                                />
                              </div>
                              <div className="col-md-6">
                                <label>Representative Mobile-4</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep4Mobile}
                                  maxLength={15}
                                  onChange={(e) => setRep4Mobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
                                />
                              </div>
                            </div>

                            {/* Rep 5 */}
                            <div className="row g-2 mt-2">
                              <div className="col-md-6">
                                <label>Representative Name-5</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep5Name}
                                  onChange={(e) => setRep5Name(e.target.value)}
                                />
                              </div>
                              <div className="col-md-6">
                                <label>Representative Mobile-5</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={rep5Mobile}
                                  maxLength={15}
                                  onChange={(e) => setRep5Mobile(e.target.value.replace(/\D/g, '').slice(0, 15))}
                                />
                              </div>
                            </div>

                            {/* Submit */}
                            <div className="form-group text-end mt-4">
                              <button type="submit" className="btn btn-success px-4">
                                Update
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </section>

                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default MemberEdit;
